export default {
  vgn: {
    name: 'Vegano',
    emoji: '🌱',
  },
  vgt: {
    name: 'Vegetariano',
    emoji: '🥬',
  },
  gf: {
    name: 'Senza glutine',
  },
  df: {
    name: 'Senza latticini',
  },
  hal: {
    name: 'Halal',
  },
  'h&s': {
    name: 'Piccante',
    emoji: '🌶',
  },
};
